import { render, staticRenderFns } from "./returnGoodslist.vue?vue&type=template&id=202eaaa5&scoped=true"
import script from "./returnGoodslist.vue?vue&type=script&lang=js"
export * from "./returnGoodslist.vue?vue&type=script&lang=js"
import style0 from "./returnGoodslist.vue?vue&type=style&index=0&id=202eaaa5&prod&scoped=true&lang=css"
import style1 from "./returnGoodslist.vue?vue&type=style&index=1&id=202eaaa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202eaaa5",
  null
  
)

export default component.exports